import { createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24c855ba")

_pushScopeId("data-v-24c855ba")
const _hoisted_1 = { class: "select-output" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Step2：4コマの出力形式", -1)
const _hoisted_4 = { class: "commands" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "戻る", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "プレビュー", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "ダウンロード", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EditDownloadSelectOutputOrder = _resolveComponent("EditDownloadSelectOutputOrder")
  const _component_EditDownloadSelectOutputDisplayOrder = _resolveComponent("EditDownloadSelectOutputDisplayOrder")
  const _component_EditDownloadSelectOutputOrderStyle = _resolveComponent("EditDownloadSelectOutputOrderStyle")
  const _component_EditDownloadSelectOutputSelect = _resolveComponent("EditDownloadSelectOutputSelect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("select", {
        class: "output-type",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.outputType = $event))
      }, [
        _createVNode("option", { value: _ctx.vAlign }, "4コマ縦のレイアウトで結合して出力", 8, ["value"]),
        _createVNode("option", { value: _ctx.split }, "4コマを4つのファイルで個別に出力", 8, ["value"]),
        _createVNode("option", { value: _ctx.twoBytwo }, "2x2のレイアウトで結合して出力", 8, ["value"]),
        _createVNode("option", { value: _ctx.splitBySelect }, "特定のコマのみを選んで出力", 8, ["value"])
      ], 512), [
        [_vModelSelect, _ctx.state.outputType]
      ]),
      (_ctx.state.outputType == _ctx.twoBytwo)
        ? (_openBlock(), _createBlock(_component_EditDownloadSelectOutputOrder, {
            key: 0,
            class: "block",
            order: _ctx.state.twoBytwoOption.order,
            "onUpdate:order": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.twoBytwoOption.order = $event))
          }, null, 8, ["order"]))
        : _createCommentVNode("", true),
      (_ctx.state.outputType == _ctx.twoBytwo)
        ? (_openBlock(), _createBlock(_component_EditDownloadSelectOutputDisplayOrder, {
            key: 1,
            class: "block",
            displayOrder: _ctx.state.twoBytwoOption.displayOrder,
            "onUpdate:displayOrder": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.twoBytwoOption.displayOrder = $event))
          }, null, 8, ["displayOrder"]))
        : _createCommentVNode("", true),
      (_ctx.state.outputType == _ctx.twoBytwo)
        ? (_openBlock(), _createBlock(_component_EditDownloadSelectOutputOrderStyle, {
            key: 2,
            class: "block",
            orderStyle: _ctx.state.twoBytwoOption.orderStyle,
            "onUpdate:orderStyle": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.twoBytwoOption.orderStyle = $event))
          }, null, 8, ["orderStyle"]))
        : _createCommentVNode("", true),
      (_ctx.state.outputType == _ctx.splitBySelect)
        ? (_openBlock(), _createBlock(_component_EditDownloadSelectOutputSelect, {
            key: 3,
            class: "block",
            images: _ctx.images,
            selectFrames: _ctx.state.selectFrames,
            "onUpdate:selectFrames": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.selectFrames = $event))
          }, null, 8, ["images", "selectFrames"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, [
        _hoisted_5
      ]),
      _createVNode("button", {
        class: "primary-button preview-button",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.preview && _ctx.preview(...args))),
        disabled: _ctx.isNotSelected
      }, [
        _hoisted_6
      ], 8, ["disabled"]),
      _createVNode("button", {
        class: "app-button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
        disabled: _ctx.isNotSelected
      }, [
        _hoisted_7
      ], 8, ["disabled"])
    ])
  ]))
})